const SirTrevor = require('sir-trevor');
const _ = require('lodash');

module.exports = (function(){

  var template = _.template([
    '<div class="st-controllable-block">',
    '<div class="st-controllable-block__content"><textarea class="st-controllable-block__text st-required"></textarea></div>',
    `<div class="st-controllable-block__footer">Code language:
      <select name="language">
        <option value="">Plain Text</option>
        <option value="bash">Bash</option>
        <option value="cpp">C++</option>
        <option value="java">Java</option>
        <option value="javascript">JavaScript</option>
        <option value="julia">Julia</option>
        <option value="perl">Perl</option>
        <option value="python">Python</option>
        <option value="r">R</option>
        <option value="typescript">TypeScript</option>
      </select>`,
    '</div></div>'
  ].join("\n"));

  return SirTrevor.Block.extend({
    type: "code",
    icon_name: "code",
    title: () => "Code",

    editorHTML: function() {
      return template(this);
    },

    loadData: function(data) {
      this.el.querySelector('.st-controllable-block__text').innerHTML = data.code;
      this.el.querySelector('select[name="language"]').value = data.language;
    },

    _serializeData: function() {
      return {
        code: this.el.querySelector('.st-controllable-block__text').value,
        language: this.el.querySelector('select[name="language"]').value
      };
    },

    focus: function() {
      this.el.querySelector('.st-controllable-block__text').focus()
    }
  });
})();
